import type { ReactNode } from 'react';
import { ArrowDown, ArrowUp, ChevronsUpDown, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';
import type { SortDirection } from './tableSort';

const SORT_ICON_BY_DIRECTION: Record<SortDirection, LucideIcon> = {
  asc: ArrowUp,
  desc: ArrowDown,
};

interface SortableColumnHeaderProps {
  label: ReactNode;
  direction: SortDirection | undefined;
  onSort: () => void;
}

export function SortableColumnHeader({ label, direction, onSort }: SortableColumnHeaderProps) {
  const SortIcon = direction ? SORT_ICON_BY_DIRECTION[direction] : ChevronsUpDown;

  return (
    <button
      type="button"
      onClick={onSort}
      className={cn(
        '-mx-1 inline-flex items-center gap-1 rounded-md px-1 py-0.5 transition-colors',
        'hover:bg-white/15 focus-visible:ring-2 focus-visible:ring-white/60 focus-visible:outline-none',
      )}
    >
      {label}
      <SortIcon
        aria-hidden
        className={cn('size-3.5 shrink-0', direction ? 'text-white' : 'opacity-50')}
      />
    </button>
  );
}
